import {
  EmojiEventsOutlined,
  CelebrationOutlined,
  CardGiftcardOutlined,
  FastfoodOutlined,
  CampaignOutlined,
  EventOutlined,
  ArticleOutlined,
  ChatBubbleOutlineOutlined,
  AddBox,
} from '@mui/icons-material';
import FeedbackOutlined from '@mui/icons-material/FeedbackOutlined';

// import GBox from '../../../assets/Gifs/GBox.gif';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
export const navigations = [
  {
    title: 'RnR',
    icon: <EmojiEventsOutlined />,
    path: 'rnr',
    feature: 'RnR',
  },
  {
    title: 'Delights',
    icon: <FastfoodOutlined />,
    path: 'delights',
    feature: 'Delights',
  },
  {
    title: 'Gift',
    icon: <CardGiftcardOutlined />,
    path: 'gift',
    feature: 'GiftForm',
  },
  {
    title: 'Shabash',
    icon: <CelebrationOutlined />,
    path: 'shabash/winners',
    feature: 'Shabash',
  },
];

export const announcementNavigation = [
  {
    icon: <ArticleOutlined />,
    title: 'GNN',
    tooltip: 'GNN',
    path: 'gnn',
    feature: 'Gnn',
  },
  {
    icon: <CampaignOutlined />,
    title: 'Pings',
    tooltip: 'Announcements',
    path: 'board',
    feature: 'Announcement',
  },
  // {
  //   icon: <EventOutlined />,
  //   title: 'Leave',
  //   tooltip: 'Leave',
  //   path: 'leave',
  //   feature: 'Leave',
  // },

    {
      title: 'Feedback',
      icon: <FeedbackOutlined />,
    tooltip: 'feedback',
    path: 'feedback',
    feature: 'feedback',
  },
  {
    icon: <WidgetsOutlinedIcon />,
    title: 'GBox',
    tooltip: 'GBox',
    path: 'gatewaybox',
    feature: 'GatewayBox',
  },
];

export const announcementNavigationMobile = [
  {
    icon: <ArticleOutlined />,
    title: 'GNN',
    tooltip: 'GNN',
    path: 'gnn',
    feature: 'Gnn',
  },
  {
    icon: <CampaignOutlined />,
    title: 'Pings',
    tooltip: 'Announcements',
    path: 'board',
    feature: 'Announcement',
  },
  // {
  //   icon: <ChatBubbleOutlineOutlined />,
  //   title: 'Chats',
  //   tooltip: 'ChatsList',
  //   path: 'chatsList',
  //   feature: 'Announcement',
  // },
  // {
  //   icon: <EventOutlined />,
  //   title: 'Leave',
  //   tooltip: 'Leave',
  //   path: 'leave',
  //   feature: 'Leave',
  // },
  {
    title: 'Delights',
    icon: <FastfoodOutlined />,
    path: 'delights',
    feature: 'Delights',
  },
  {
    icon: <WidgetsOutlinedIcon />,
    title: 'GBox',
    tooltip: 'GBox',
    path: 'gatewaybox',
    feature: 'GatewayBox',
  },
];
